@if (isAdmin) {
<div class="relative">
  <app-tooltip content="Feedback notifications" placement="bottom">
  <button
    class="relative flex items-center justify-center text-gray-500 transition-colors bg-white border border-gray-200 rounded-full dropdown-toggle hover:text-gray-700 h-11 w-11 hover:bg-gray-100 dark:border-gray-800 dark:bg-gray-900 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-white"
    (click)="toggleDropdown()"
  >
    @if (newCount > 0) {
      <span class="absolute right-0 top-0.5 z-10 h-2 w-2 rounded-full bg-orange-400 flex">
        <span class="absolute inline-flex w-full h-full bg-orange-400 rounded-full opacity-75 animate-ping"></span>
      </span>
    }
    <svg
      class="fill-current"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.75 2.29248C10.75 1.87827 10.4143 1.54248 10 1.54248C9.58583 1.54248 9.25004 1.87827 9.25004 2.29248V2.83613C6.08266 3.20733 3.62504 5.9004 3.62504 9.16748V14.4591H3.33337C2.91916 14.4591 2.58337 14.7949 2.58337 15.2091C2.58337 15.6234 2.91916 15.9591 3.33337 15.9591H4.37504H15.625H16.6667C17.0809 15.9591 17.4167 15.6234 17.4167 15.2091C17.4167 14.7949 17.0809 14.4591 16.6667 14.4591H16.375V9.16748C16.375 5.9004 13.9174 3.20733 10.75 2.83613V2.29248ZM14.875 14.4591V9.16748C14.875 6.47509 12.6924 4.29248 10 4.29248C7.30765 4.29248 5.12504 6.47509 5.12504 9.16748V14.4591H14.875ZM8.00004 17.7085C8.00004 18.1228 8.33583 18.4585 8.75004 18.4585H11.25C11.6643 18.4585 12 18.1228 12 17.7085C12 17.2943 11.6643 16.9585 11.25 16.9585H8.75004C8.33583 16.9585 8.00004 17.2943 8.00004 17.7085Z"
        fill="currentColor"
      />
    </svg>
  </button>
  </app-tooltip>

  <app-dropdown
    [isOpen]="isOpen"
    (close)="closeDropdown()"
    className="absolute -right-[240px] mt-[17px] flex h-[520px] w-[380px] flex-col rounded-2xl border border-gray-200 bg-white p-3 shadow-theme-lg dark:border-gray-800 dark:bg-gray-dark sm:w-[380px] lg:right-0"
  >
    <div class="flex items-center justify-between pb-3 mb-3 border-b border-gray-100 dark:border-gray-700">
      <h5 class="text-lg font-semibold text-gray-800 dark:text-gray-200">
        Feedback
        @if (newCount > 0) {
          <span class="ml-2 inline-flex items-center justify-center rounded-full bg-orange-100 px-2 py-0.5 text-xs font-medium text-orange-700 dark:bg-orange-900/30 dark:text-orange-400">
            {{ newCount }} new
          </span>
        }
      </h5>
      <button
        (click)="closeDropdown()"
        class="text-gray-500 transition dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200"
      >
        <svg class="fill-current" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M6.21967 7.28131C5.92678 6.98841 5.92678 6.51354 6.21967 6.22065C6.51256 5.92775 6.98744 5.92775 7.28033 6.22065L11.999 10.9393L16.7176 6.22078C17.0105 5.92789 17.4854 5.92788 17.7782 6.22078C18.0711 6.51367 18.0711 6.98855 17.7782 7.28144L13.0597 12L17.7782 16.7186C18.0711 17.0115 18.0711 17.4863 17.7782 17.7792C17.4854 18.0721 17.0105 18.0721 16.7176 17.7792L11.999 13.0607L7.28033 17.7794C6.98744 18.0722 6.51256 18.0722 6.21967 17.7794C5.92678 17.4865 5.92678 17.0116 6.21967 16.7187L10.9384 12L6.21967 7.28131Z"
            fill="currentColor"
          />
        </svg>
      </button>
    </div>

    <!-- Tabs -->
    <div class="flex gap-1 mb-3 rounded-lg bg-gray-100 p-1 dark:bg-gray-800">
      @for (tab of tabs; track tab) {
        <button
          (click)="switchTab(tab)"
          class="flex-1 rounded-md py-1.5 text-xs font-medium transition-colors"
          [class.bg-white]="activeTab === tab"
          [class.text-gray-800]="activeTab === tab"
          [class.shadow-sm]="activeTab === tab"
          [class.text-gray-500]="activeTab !== tab"
          [class.dark:bg-gray-700]="activeTab === tab"
          [class.dark:text-white]="activeTab === tab"
          [class.dark:text-gray-400]="activeTab !== tab"
        >{{ tab | titlecase }}</button>
      }
    </div>

    <!-- Items list -->
    <ul class="flex flex-col flex-1 overflow-y-auto custom-scrollbar gap-1">
      @if (isLoading) {
        <li class="flex items-center justify-center py-10 text-gray-400 text-sm">
          Loading...
        </li>
      } @else if (feedbackItems.length === 0) {
        <li class="flex items-center justify-center py-10 text-gray-400 text-sm dark:text-gray-500">
          No {{ activeTab }} feedback
        </li>
      } @else {
        @for (item of feedbackItems; track item.id) {
          <li class="rounded-lg border border-gray-100 p-3 dark:border-gray-700">
            <p class="text-sm text-gray-800 dark:text-white/90 mb-2 leading-snug">{{ item.text }}</p>
            <div class="flex items-center justify-between gap-2">
              <div class="flex flex-col gap-0.5 min-w-0">
                <span class="text-xs font-medium text-gray-700 dark:text-gray-300">{{ getUserName(item.userId) }}</span>
                @if (item.url) {
                  <a
                    [href]="item.url"
                    target="_blank"
                    rel="noopener"
                    class="text-xs text-brand-500 hover:underline truncate max-w-[180px]"
                    [title]="item.url"
                  >{{ truncateUrl(item.url) }}</a>
                }
                <span class="text-xs text-gray-400 dark:text-gray-500">{{ item.timestamp | date:'MMM d, y, h:mm a' }}</span>
              </div>
              <div class="flex gap-1 shrink-0">
                @if (activeTab === 'new') {
                  <button
                    (click)="updateStatus(item, 'read')"
                    class="rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 hover:bg-blue-100 dark:bg-blue-900/30 dark:text-blue-300 dark:hover:bg-blue-900/50"
                  >Mark Read</button>
                }
                @if (activeTab === 'read') {
                  <button
                    (click)="updateStatus(item, 'complete')"
                    class="rounded-md bg-success-50 px-2 py-1 text-xs font-medium text-success-700 hover:bg-success-100 dark:bg-success-900/30 dark:text-success-300 dark:hover:bg-success-900/50"
                  >Complete</button>
                }
                @if (activeTab === 'complete') {
                  <button
                    (click)="updateStatus(item, 'read')"
                    class="rounded-md bg-gray-100 px-2 py-1 text-xs font-medium text-gray-600 hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600"
                  >Re-open</button>
                }
              </div>
            </div>
          </li>
        }
      }
    </ul>
  </app-dropdown>
</div>
}
